module.exports = __webpack_public_path__ + "img/dw1.bd7f5337.jpg";